import React from 'react';

function Heading3({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M 3 6, v 12" />
      <path d="M 3.5 12, h 8" />
      <path d="M 12 6, v 12" />
      <path d="M16.5 12C17 10.5 18 10.5 18.5 10.5C20 10.5 21 12.5 18.5 14" />
      <path d="M16.5 16.5C17 18 18 18 18.6379 18C20.1864 18 21.5 15 18.5 14" />
    </svg>
  );
}

export default Heading3;
